<template>
  <div class='YUpload'>
    <el-upload
      :action="imgUrl"
      :headers='token'
      name='fileName'
      :data='imgData()'
      :on-success='onSuccess'
      :on-remove="onRemove"
      :before-upload="beforeAvatarUpload"
      :file-list="value"
      :list-type="type">
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip" v-if="remark">{{remark}}</div>
    </el-upload>
  </div>
</template>

<script>
import api from '@/shared/api/auth'
import apiUrl from '@/shared/api/config/api'
import Params from '@/shared/utils/Params'
export default {
  name: 'YUpload',

  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    },

    type: {
      type: String,
      default: 'text'
    },

    remark: {
      type: String,
      default: '上传文件不超过5MB'
    },

    size: {
      type: Number && String,
      default: '5'
    }
  },

  data () {
    return {
      fileList: [],
      token: { Authorization: sessionStorage.getItem('token') },
      imgUrl: `${apiUrl.api.protocol}://${apiUrl.api.host}:${apiUrl.api.port === '' ? '' : apiUrl.api.port === '80' ? '' : apiUrl.api.port}`
    }
  },

  methods: {
    onSuccess (res, file, fileList) {
      if (res.backend_org_sys_file_upload_response.code !== '10000') return
      this.value.push({
        name: file.name,
        uid: file.uid,
        url: file.response.backend_org_sys_file_upload_response.url
      })
    },

    onRemove (file, fileList) {
      this.$emit('input', fileList)
    },

    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < parseInt(this.size)

      if (this.type === 'picture') {
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 或者 PNG 格式!')
        }
        if (!isLt5M) {
          this.$message.error(`上传文件大小不能超过 ${this.size}MB!`)
        }
        return isJPG && isLt5M
      } else {
        if (!isLt5M) {
          this.$message.error(`上传文件大小不能超过 ${this.size}MB!`)
        }
        return isLt5M
      }
    },

    imgData () {
      return Params({}, api.upload)
    }
  }
}
</script>

<style lang='stylus' scoped>

</style>
